import { useEffect } from 'react'

type RefetchFn = () => Promise<unknown>

type UseRefetchOnReconnectOptions = {
  enabled: boolean
  refetch: RefetchFn
}

export function useRefetchOnReconnect({ enabled, refetch }: UseRefetchOnReconnectOptions) {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      return
    }

    const handleOnline = () => {
      void refetch()
    }

    window.addEventListener('online', handleOnline)
    return () => {
      window.removeEventListener('online', handleOnline)
    }
  }, [enabled, refetch])
}
